import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

// Clinical Pathway Definitions
async function getDefinitions(params?: any) {
  const response = await http
    .getDataParam("/mutu/cp-compliance/definitions", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function findDefinition(id: number) {
  const response = await http
    .getData(`/mutu/cp-compliance/definitions/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function createDefinition(data: any) {
  const response = await http
    .postData("/mutu/cp-compliance/definitions", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateDefinition(id: number, data: any) {
  const response = await http
    .putData(`/mutu/cp-compliance/definitions/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroyDefinition(id: number) {
  const response = await http
    .deleteData(`/mutu/cp-compliance/definitions/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// CP Compliance Sessions
async function getList(params?: any) {
  const response = await http
    .getDataParam("/mutu/cp-compliance/sessions", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/mutu/cp-compliance/sessions/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/mutu/cp-compliance/sessions", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/mutu/cp-compliance/sessions/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/mutu/cp-compliance/sessions/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function submit(id: number, data: any) {
  const response = await http
    .postData(`/mutu/cp-compliance/sessions/${id}/submit`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// 3-tier signing
async function signPpa(id: number, data: { password: string }) {
  const response = await http
    .postData(`/mutu/cp-compliance/sessions/${id}/sign-ppa`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signKaSmf(id: number, data: { password: string }) {
  const response = await http
    .postData(`/mutu/cp-compliance/sessions/${id}/sign-ka-smf`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signKomite(id: number, data: { password: string }) {
  const response = await http
    .postData(`/mutu/cp-compliance/sessions/${id}/sign-komite`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Patient lookup (auto-fill from RegisterPelayanan + ResumeRanap)
async function lookupPatient(registerId: number) {
  const response = await http
    .getData(`/mutu/cp-compliance/lookup-patient/${registerId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Patient list picker (daftar register ranap: rentang tgl + unit + cari)
async function getPatientCandidates(params?: any) {
  const response = await http
    .getDataParam("/mutu/cp-compliance/patient-candidates", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Dashboard & Rekap
async function getDashboard(params?: any) {
  const response = await http
    .getDataParam("/mutu/cp-compliance/dashboard", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getRekapHarian(params?: any) {
  const response = await http
    .getDataParam("/mutu/cp-compliance/rekap-harian", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// PDF
function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/mutu/cp-compliance/sessions/${id}/pdf`,
    "_blank"
  );
}

export default {
  // Definitions
  getDefinitions,
  findDefinition,
  createDefinition,
  updateDefinition,
  destroyDefinition,
  // Sessions
  getList,
  find,
  create,
  update,
  destroy,
  submit,
  // Signing
  signPpa,
  signKaSmf,
  signKomite,
  // Lookup
  lookupPatient,
  getPatientCandidates,
  // Dashboard
  getDashboard,
  getRekapHarian,
  // PDF
  printPdf,
};
